// ./src/utils/textFormatCarry.ts
//
// What happens to host-written text when its editor FORMAT changes (richtext | markdown | html | plain). Import-free, so
// a guard can run it.

const escapeHtml = (value: string): string =>
  value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');

/**
 * Host-written text, carried over when its FORMAT is switched (the Schedule drawer's session description, the page
 * editor's text block). Plain text upgraded to rich text would otherwise be read as HTML: line breaks collapse and a `<`
 * becomes markup. So plain → rich text / HTML becomes one escaped paragraph per line.
 * ⓘ Any other switch keeps the text as it is: Markdown shows its own preview, and nothing is guessed back to plain.
 */
export const carryTextOver = (text: string, from: string, to: string): string => {
  if (from !== 'plain' || (to !== 'richtext' && to !== 'html') || !text.trim()) {
    return text;
  }

  return text
    .split(/\r?\n/)
    .filter((line) => line.trim())
    .map((line) => `<p>${escapeHtml(line)}</p>`)
    .join('');
};
